import React, { Component } from 'react';
import ProfileTopAction from './ProfileTopAction';
import Link from 'react-router/lib/Link';
import logo from '../assets/images/logo.png';
class Header extends Component {
    render() {

        return (
            <div className="row banner hidden-sm hidden-xs">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="logo">
                                <Link to="/">
                                    <img src={ logo } width="368" height="82" alt="presentation"/>
                                </Link>
                            </div>
                        </div>

                        <ProfileTopAction isLogin={ this.props.isLogin }/>
                        
                    </div>
                </div>
            </div>
        );
    }
}

export default Header



// WEBPACK FOOTER //
// ./src/partials/Header.js